import { render, staticRenderFns } from "./create-edit-template-mailing.vue?vue&type=template&id=5336439b&scoped=true"
import script from "./create-edit-template-mailing.vue?vue&type=script&lang=js"
export * from "./create-edit-template-mailing.vue?vue&type=script&lang=js"
import style0 from "./create-edit-template-mailing.vue?vue&type=style&index=0&id=5336439b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336439b",
  null
  
)

export default component.exports